module.exports = __webpack_public_path__ + "static/media/desc-image.175dc31e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/desc-image.jpg
// module id = 206
// module chunks = 0